import React, { useEffect, useState } from 'react';
import { ICharacterAbilityProps } from 'utils/types/platformTypes';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import styled from 'styled-components';
import CircleButton from 'components/button/CircleButton';
import {
  useAbilityCharacterDropList,
  useAbilityDropList,
} from 'hooks/queries/platform/currencyQuery';
import { useTranslation } from 'react-i18next';
/**
 * * 작품(오토메) - 의상 판매 등록 & 수정
 * * 능력치 리스트 - 재화 관리로 이동 해야겠다. (23.1.18)
 */

interface IProps {
  abilityData?: ICharacterAbilityProps[];
  setAbilityData: (e: any) => void;
  projectId?: number;
}
const CharacterAbilityList = ({
  abilityData,
  setAbilityData,
  projectId,
}: IProps) => {
  const { t } = useTranslation();
  const [speaker, setSpeaker] = useState<string[]>([]);
  const { data: abilityCharacterDropList } =
    useAbilityCharacterDropList(projectId);

  const abilityDropList = useAbilityDropList(projectId, speaker);

  /// 적용 캐릭터
  const handleCharacterChange = (val, option) => {
    setAbilityData(
      abilityData?.map((v) =>
        v.key === Number(option.id)
          ? { ...v, speaker: val, ability_id: -1 }
          : v,
      ),
    );
    for (let i = 0; speaker?.length > i; i++) {
      if (i === Number(option.id)) {
        speaker[i] = val;
      }
    }
    setSpeaker(speaker);
  };

  /// 적용 능력
  const handleAbilityChange = (val, option) => {
    setAbilityData(
      abilityData?.map((v) =>
        v.key === Number(option.id) ? { ...v, ability_id: Number(val) } : v,
      ),
    );
  };

  /// 수치 입력
  const handleNumberInput = (e) => {
    const { value, id } = e.target;
    setAbilityData(
      abilityData?.map((v) =>
        v.key === Number(id) ? { ...v, add_value: value } : v,
      ),
    );
  };

  /// 행 추가
  const handleAdditionalClick = (e) => {
    setAbilityData([
      ...abilityData!,
      { key: abilityData?.length, ability_id: -1, add_value: 0, speaker: '' },
    ]);
    setSpeaker([...speaker, '']);
  };

  /// 행 삭제
  const handleSubtractionClick = (e) => {
    const { id, name } = e.target;

    const newArr = abilityData?.filter((v) => v.key !== Number(name));

    const newArr2 = newArr?.map((v, i) => ({ ...v, key: i }));

    setAbilityData(newArr2);

    // const speakerArr = speaker.filter((v, i) => console.log(v, i));
    const speakerArr = speaker.filter((v, i) => i !== Number(name));

    setSpeaker(speakerArr);
  };

  useEffect(() => {
    const newArr: string[] = [];
    abilityData?.map((v) => newArr.push(v.speaker));
    setSpeaker(newArr);
  }, [abilityData]);
  return (
    <Container>
      <thead>
        <tr>
          <th>{t('currencyMasterID.formSix.appliedCharacter')}</th>
          <th>{t('currencyMasterID.formSix.appliedAbility')}</th>
          <th>{t('currencyMasterID.formSix.value')}</th>
          <th className='button_td'></th>
          <th className='button_td'></th>
        </tr>
      </thead>
      <tbody>
        {abilityData?.map((v, i) => (
          <tr key={i}>
            <td>
              <DefaultSelect
                name='speaker'
                id={`${i}`}
                value={v.speaker}
                optionList={abilityCharacterDropList}
                onChange={handleCharacterChange}
              />
            </td>
            <td>
              <DefaultSelect
                name='ability_id'
                id={`${i}`}
                value={v.ability_id}
                optionList={abilityDropList?.result[i].data}
                onChange={handleAbilityChange}
              />
            </td>
            <td>
              <DefaultInput
                type='number'
                name='add_value'
                id={`${i}`}
                value={v.add_value}
                onChange={handleNumberInput}
              />
            </td>
            <td className='button_td'>
              <CircleButton
                name='additional'
                id={`${v.ability_id}`}
                onClick={handleAdditionalClick}
                disabled={abilityData?.length >= 2 ? true : false}
              >
                +
              </CircleButton>
            </td>

            <td className='button_td'>
              <CircleButton
                name={`${i}`}
                id={`${v.ability_id}`}
                onClick={handleSubtractionClick}
                disabled={abilityData?.length <= 1 ? true : false}
              >
                -
              </CircleButton>
            </td>
          </tr>
        ))}
      </tbody>
    </Container>
  );
};

export default CharacterAbilityList;
const Container = styled.table`
  width: 100%;
  tr > th {
    width: 10rem;
  }
  td {
    padding-right: 1rem;
  }
  .button_td {
    width: 0rem;
    padding-right: 0.2rem;
  }
`;
